import { createContext } from 'react';

const TryContext = createContext();

export default TryContext;
